import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8v8h4","key":"svg-1"}]]

const IconCircleLetterL = createReactComponent('outline', 'circle-letter-l', 'CircleLetterL', __iconNode);

export default IconCircleLetterL;